export const createTooltipAnchor = (value: number | string): string => `tooltip-anchor-${value}`;
